// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-box[data-v-4478fdfb] {\n  padding: 0 0.24rem;\n  flex-direction: row;\n}\n.empty-list[data-v-4478fdfb] {\n  font-size: 0.37333rem;\n}\n", ""]);
// Exports
module.exports = exports;
